import { Providers } from './Providers';
import { Router } from './router/Router';

function App() {
  return (
    <Providers>
      <Router />
    </Providers>
  );
}

export default App;
